export function move(
  arr: string[],
  fromIndex: number,
  toIndex: number
): string[] {
  ;[arr[fromIndex], arr[toIndex]] = [arr[toIndex], arr[fromIndex]]

  return arr
}

export const clean = (elements: string[]): string[] =>
  elements.filter(
    (el, i) =>
      (!i && !['AND', 'OR'].includes(el)) ||
      (i === elements.length - 1 && !['AND', 'OR'].includes(el)) ||
      (i && i !== elements.length - 1)
  )

export const mergeElements = (
  { elements, i }: { elements: string[]; i: number },
  isClean?: boolean
): string[] => {
  let start = false
  let finish = false

  elements.forEach((element, index) => {
    if (!isClean && !finish) {
      // isFinish
      if (index > i && parseInt(element)) {
        elements.splice(index + 1, 0, ')')
        finish = true
      }
    } else if (!finish) {
      // isFinish
      if (
        index === i + 2 &&
        !parseInt(element) &&
        !['AND', 'OR'].includes(element)
      ) {
        elements.splice(index, 1)
        finish = true
      }
    }
  })

  elements.forEach((element, index) => {
    if (!isClean && !start) {
      // isStart
      if (index >= (i - 1 || 0) && parseInt(element)) {
        elements.splice(index, 0, '(')
        start = true
      }
    } else if (!start) {
      // isStart
      if (
        index === i - 2 &&
        !parseInt(element) &&
        !['AND', 'OR'].includes(element)
      ) {
        elements.splice(index, 1)
        start = true
      }
    }
  })

  return clean(elements)
}
